<template>
  <Typography tag="td" color="gray800">
    <div class="meeting-wrapper">
      <div class="meeting-item">
        <div class="meeting-items-flex">
          <span class="meeting-item-col">
            <typography color="primary400" weight="600" transform="uppercase">{{
              agenda.flag === "O" ? "Teacher meeting" : "Team meeting"
            }}</typography>
            <typography
              v-if="agenda.flag !== 'O' || 'teacher_name' in agenda"
              color="gray700"
              class="pl-3"
              weight="400"
              transform="capitalize"
            >
              {{ agenda.flag === "O" ? (agenda as any).teacher_name : agenda.team_name }}
            </typography>
          </span>
          <span class="meeting-item-col">
            <typography color="gray700" weight="600" transform="uppercase">Parent</typography>
            <typography color="gray700" class="pl-3" weight="400" transform="capitalize">
              {{ agenda.parent_name }}
            </typography>
          </span>
          <span class="meeting-item-col">
            <typography color="gray700" weight="600" transform="uppercase"> Student </typography>
            <typography color="gray700" class="pl-3" weight="400" transform="capitalize">
              <div>{{ agenda.child_name }} <span style="font-size: small" v-if="agenda.child_description"> ( {{ agenda.child_description }} )</span></div> 
            </typography>
          </span>
          <template v-if="agenda.flag == 'T'">
            <span class="meeting-item-col">
              <typography color="gray700" weight="600" transform="uppercase">
                Meeting Type
              </typography>
              <typography color="gray700" class="pl-3" weight="400" transform="capitalize">
                {{ parseMeetingType(agenda.meeting_type) }}
              </typography>
            </span>

            <MeetingTypeView :conference-day="conferenceDay" :agenda="agenda"></MeetingTypeView
          ></template>
        </div>
      </div>
    </div>
  </Typography>
  <td v-if="showComments">
    <div class="comment-preview" v-if="agenda.comment && agenda.flag == 'T'">
      <p>{{ agenda.comment }}</p>
      <v-btn
        icon
        size="small"
        variant="text"
        @click="state.comment = agenda.comment!"
        data-cy="comment-view-btn"
      >
        <v-tooltip activator="parent" class="custom-tooltip" location="bottom">
          {{ agenda.comment }}
        </v-tooltip>
        <v-icon icon="mdi-message-outline" size="1rem" color="primary"> </v-icon>
      </v-btn>
    </div>
  </td>
  <td v-if="noShow"></td>
  <ModalMeetingComment
    v-if="state.comment"
    :comment="state.comment"
    :show="true"
    @close="state.comment = ''"
  >
  </ModalMeetingComment>
</template>

<script setup lang="ts">
import type { ConferenceDay, GetSchedule } from "@/api_types/teacher";
import Typography from "../typography.vue";
import MeetingTypeView from "../global/MeetingTypeView.vue";
import { reactive } from "vue";
import ModalMeetingComment from "@/components/teacher/modal/MeetingComment.vue";

// const props =
defineProps<{
  agenda: GetSchedule;
  noShow: boolean;
  showComments: boolean;
  conferenceDay: ConferenceDay;
}>();

const state = reactive({
  comment: ""
});

const parseMeetingType = (type) => {
  if (type === "in_person") return "In Person";
  return type || "Not Available";
};
// props.agenda.flag = "R";
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.meeting-wrapper {
  display: flex;
  align-items: center;
  min-height: 45px;
  gap: 10px;
  flex-wrap: wrap;

  .meeting-item {
    display: flex;
    justify-content: space-between;
    min-height: 45px;
    flex: 1;
    align-items: center;
    border-radius: 4px;
    padding: 0 10px;
    width: 100%;

    background-color: $primary-50;
    border: 1px solid $primary;
    &.team {
      background-color: $primary-100;
    }
  }
}

.meeting-items-flex {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: 1px 13px;
  :deep(.meeting-item-col) {
    display: flex;
    > span {
      white-space: nowrap;
    }
  }
}
</style>
